import { render, staticRenderFns } from "./supplierQuoteList.vue?vue&type=template&id=bc05bba2&scoped=true"
import script from "./supplierQuoteList.vue?vue&type=script&lang=js"
export * from "./supplierQuoteList.vue?vue&type=script&lang=js"
import style0 from "./supplierQuoteList.vue?vue&type=style&index=0&id=bc05bba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc05bba2",
  null
  
)

export default component.exports